import { gql } from '@apollo/client'

import { useMutation } from 'hooks'

const CONFIG_UPDATE_MUTATION = gql`
  mutation ConfigUpdate($configId: Long!, $config: ConfigUpdate) {
    configUpdate(id: $configId, config: $config) {
      id
      name
      value
      description
      errors {
        message
      }
    }
  }
`

export const useConfigUpdateMutation = (configId, opts) =>
  useMutation(CONFIG_UPDATE_MUTATION, opts, { configId })
